/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query PartnersQuery($uid: String!) {
    prismic {
      partners(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_PartnersBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_PartnersBodyDynamicformbuilder {
          type
          label
          primary {
            footer_form_text
            form_anchor_name
            form_post_location
            header_form_text
            marketo_form_id
            munchkin_account_id
            sub_header_form_text
            thank_you_message
            analytics_track
            analytics_action
          }
          fields {
            field_alphanumeric
            field_column_width
            field_error_message
            field_max_length
            field_name
            field_placeholder
            field_post_name
            field_required
            field_type
            field_value
            section_header
            section_sub_header
          }
        },
        ... on PRISMIC_PartnersBodyFeatureslist {
          type
            label
            primary {
              background_color
              background_image
              cta_button_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              item_text_color
              heading_color
              item_title_color
              subheading
              subheading_color
              text_color
            }
            fields {
              item_icon
              item_text
              item_title
            }
        },
        ... on PRISMIC_PartnersBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_PartnersBodyLogogrid {
          type
            label
            fields {
              logo
            }
            primary {
              text_color
              autoScroll
              background_color
              cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_text
              heading
              heading_color
              subheading
              subheading_color
              scroll_speed
            }
        },
        ... on PRISMIC_PartnersBodyCarouseltestimonial {
          type
            label
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading1
              subheading_color
            }
            fields {
              logo
              quote
              author
              author_details
              avatar
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_text
            }
        },
        ... on PRISMIC_PartnersBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_PartnersBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_PartnersBodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_PartnersBodyResourcetable {
          
  type
  label
  primary {
    background_color
    heading
    heading_color
    subheading
    subheading_color
    text_color
  }
  fields {
    section_title
    section_subtitle
    title_1
    title_2
    title_3
    title_4
    copy_1
    copy_2
    copy_3
    copy_4
    icon_1
    icon_2
    icon_3
    icon_4
    subcopy_1
    subcopy_2
    subcopy_3
    subcopy_4
    subtitle_1
    subtitle_2
    subtitle_3
    subtitle_4
  }

        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Partners = ({ data, location }) =>
  data.prismic.partners ? (
    <MainLayout location={location} layout='partners'>
    <Helmet>
      <title>{(data.prismic.partners.title[0] && data.prismic.partners.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.partners.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.partners.path : 'https://www.digitalocean.com' + data.prismic.partners.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.partners.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.partners.title[0] ? data.prismic.partners.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.partners.description ? data.prismic.partners.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.partners.open_graph_image ? data.prismic.partners.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.partners.description ? data.prismic.partners.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.partners.title[0] ? data.prismic.partners.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.partners.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.partners.path : 'https://www.digitalocean.com' + data.prismic.partners.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.partners.open_graph_image ? data.prismic.partners.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.partners.body} />
    </MainLayout>
  ) : null;

Partners.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Partners;
